import styled, { css } from 'styled-components';

export const RegisterInputContainer = styled.div(
  ({ theme }) => css`
    margin-top: ${theme.grid * 3}px;
    max-width: ${theme.grid * 45}px;
  `,
);
